export default {
  data() {
    return {
      socket: null
    }
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
      this.socket = null
    }
  },
  methods: {
    socketOpen(socketUrl, requestId, callback, errCallback) {
      const data = {
        action: 'registerConnection',
        requestId: requestId
      }

      if (!this.socket) {
        this.socket = new WebSocket(socketUrl)

        this.socket.onopen = () => {
          this.socket.send(JSON.stringify(data))
        }
      } else {
        this.socket.send(JSON.stringify(data))
      }

      this.socket.onmessage = callback
      this.socket.onerror = err => {
        this.socket = null
        errCallback(err)
      }

      this.socket.onclose = () => {
        this.socket = null
      }
    }
  }
}
